import { FC } from "react";
import styled, { css } from "styled-components";

import Text from "@/components/Text";
import { EytvStatus } from "@/utils/enums";

const StyledText = styled(Text)`
  display: flex;
  align-items: center;
`;

const Dot = styled.span<{ $status: EytvStatus }>`
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-right: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  ${({ theme, $status }) =>
    $status === EytvStatus.New &&
    css`
      background: ${theme.colors.info};
    `}
  ${({ theme, $status }) =>
    $status === EytvStatus.Pending &&
    css`
      background: ${theme.colors.warning};
    `}
    ${({ theme, $status }) =>
    $status === EytvStatus.Downloaded &&
    css`
      background: ${theme.colors.gray};
    `}
    ${({ theme, $status }) =>
    $status === EytvStatus.Done &&
    css`
      background: ${theme.colors.success};
    `}
`;

interface Props {
  status: EytvStatus;
}
const renderStatus = (fileStatus: EytvStatus) => {
  switch (fileStatus) {
    case EytvStatus.New:
      return "New";
    case EytvStatus.Pending:
      return "Pending";
    case EytvStatus.Downloaded:
      return "Downloaded";
    case EytvStatus.Done:
      return "Done";
  }
};

const EytvFilesStatus: FC<Props> = ({ status }) => {
  return (
    <StyledText $type="smallHeadline">
      <Dot $status={status} />
      {renderStatus(status)}
    </StyledText>
  );
};

export default EytvFilesStatus;
